var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "11px",
    height: "12px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -637 -341 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.8012903225806 1.65656565656566  C 10.9337634408602 1.84511784511784  11 2.07407407407407  11 2.34343434343434  C 11 2.61279461279461  10.9337634408602 2.84175084175084  10.8012903225806 3.03030303030303  L 5.66322580645161 10.3434343434343  L 4.69806451612903 11.7171717171717  C 4.56559139784946 11.9057239057239  4.4047311827957 12  4.21548387096774 12  C 4.02623655913979 12  3.86537634408602 11.9057239057239  3.73290322580645 11.7171717171717  L 2.76774193548387 10.3434343434343  L 0.198709677419355 6.68686868686869  C 0.066236559139785 6.4983164983165  0 6.26936026936027  0 6  C 0 5.73063973063973  0.066236559139785 5.5016835016835  0.198709677419355 5.31313131313131  L 1.16387096774194 3.93939393939394  C 1.29634408602151 3.75084175084175  1.45720430107527 3.65656565656566  1.64645161290323 3.65656565656566  C 1.83569892473118 3.65656565656566  1.99655913978495 3.75084175084175  2.12903225806452 3.93939393939394  L 4.21548387096774 6.91919191919192  L 8.87096774193548 0.282828282828283  C 9.00344086021505 0.0942760942760938  9.16430107526882 0  9.35354838709677 0  C 9.54279569892473 0  9.7036559139785 0.0942760942760938  9.83612903225806 0.282828282828283  L 10.8012903225806 1.65656565656566  Z ",
    fillRule: "nonzero",
    fill: "#70b603",
    stroke: "none",
    transform: "matrix(1 0 0 1 637 341 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputTick);
export default __webpack_public_path__ + "static/media/input-tick.3e1c4f2ac6a521aee3737966c6582978.svg";
export { ForwardRef as ReactComponent };